import { Pipe, PipeTransform } from '@angular/core';
import { RemoveParentActorPipe } from './remove-parent-actor.pipe';
import { LssDeploymentEntity } from '../store/deployment.datamodel';

/**
 * Pipe to join the names of the actors of a list of entities.
 */
@Pipe({
    name: 'joinEntities',
    standalone: false
})
export class JoinEntitiesPipe implements PipeTransform {

  private readonly RemoveParentActorPipe: RemoveParentActorPipe = new RemoveParentActorPipe();

  transform(entities: LssDeploymentEntity[], sep = ', '): string {
    return entities.map((entity: LssDeploymentEntity) =>
      this.RemoveParentActorPipe.transform(entity.actor.actorName, entity.parentOrg?.actorName))
      .join(sep);
  }

}
